<template>
  <tr class="analysisRow">
    <td>{{ analysisTitle }}</td>
    <td
      v-for="head in analysesTableHeads"
      :key="head.action"
    >
      <VCheckbox
        :color="head.color"
        :value="getActionVal(head.action)"
        :readonly="readOnly"
        datacy="checkboxAlert"
        @input="(val)=>onChecboxChange(val,head.action)"
      />
    </td>
  </tr>
</template>
<script>

import { mapGetters } from 'vuex';
import VCheckbox from '../shared/widgets/forms/VuetifyInputs/VCheckbox.vue';

export default {
    components: { VCheckbox },
    props: {
        analysis: {
            type: Object,
            default: () => {},
        },
        siteId: {
            type: String,
            required: true,
        },
        componentId: {
            type: String,
            required: true,
        },
        analysesTableHeads: {
            type: Array,
            default: () => [],
        },
        normsVal: {
            type: Object,
            default: () => {},
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters([
            'siteLang',
            'lang',
            'userLang',
            'teamMainLang',

        ]),
        analysisTitle() {
            const { name = {} } = this.analysis.analysisType;
            return name[this.siteLang] || name[this.userLang] || name[this.teamMainLang];
        },
    },
    methods: {
        getActionVal(mode) {
            return (this.normsVal?.norms ? this.normsVal.norms[mode] : false);
        },
        onChecboxChange(val, checkboxType) {
            const parentObj = {
                parentNetwork: this.analysis.component.parentNode,
                component: this.analysis.component.id,
            };
            this.$emit('onSelectionChange', { id: this.analysis.analysisType.id, normVal: val, normLevel: checkboxType, ...parentObj });
        },
    },
};
</script>

<style scoped lang="scss">
    .analysisRow {
        td:nth-child(1) {
            white-space: nowrap;
        }
    }
</style>
